<template>
  <div class="nav-header">
    <el-menu :default-active="activeIndex" class="nav-menu" :class="[style]" mode="horizontal">
      <el-menu-item index="0">
        <a href="/" title="数据概览"><img class="josh-logo" src="@/assets/public/logo.png"></a>
      </el-menu-item>
      <el-dropdown v-if="userName" class="lang-select pull-right" @command="clickFunction">
        <span class="el-dropdown-link">
          {{ userName }} <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="reset">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          <!-- <el-dropdown-item command="version">版本信息</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>
    <EditPassword :show="showPwd" @receive="getReceive"/>
  </div>
</template>

<script>
import lang from '@/options/lang'
import EditPassword from '@/components/account/EditPassword'
export default {
  data () {
    return {
      activeIndex: this.index,
      activeLang: '',
      lang: lang,
      userName: null,
      style: this.className,
      showPwd: false
    }
  },
  components: {
    EditPassword
  },
  props: {
    index: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    }
  },
  created() {
    var lang = this.$root.getStorage('cloud_lang')
    this.activeLang = ((lang) ? this.lang[lang].name : '简体中文')
    this.userName = this.Cookies.get('cloud_U')
  },
  methods: {
    getReceive(data) {
      this[data.key] = data.value
    },
    changeLang(value) {
      this.$root.setStorage('cloud_lang',value)
      window.location.reload()
    },
    clickFunction(value) {
      switch(value) {
        case 'reset':
          this.showPwd = true
        break
        case 'logout':
          this.logout()
        break
        case 'version':
          this.$notify.info({
            title: '版本信息',
            message: `当前平台版本${this.$root.version}`
          });
        break
      }
    },
    logout() {
      this.$confirm(
        '确认退出登录？',
        '系统提示',
        {
          confirmButtonText: '立即退出',
          cancelButtonText: '暂不退出',
          type: 'info'
        }
      ).then(() => {
        this.doLogOut()
      })
    },
    doLogOut() {
      this.request({
        url: '/system/logout',
        method: 'post',
        data: {}
      }).then(response => {
        this.Cookies.remove('cloud_U')
        this.store.commit('REMOVE_STATUS')
        location.reload()
      }).catch(error => {
        this.$message({
          message: error.errmsg,
          type: 'error',
          duration: 3 * 1000
        })
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/css/style.scss';
$font-color: #909399;
.nav-header {
  background-color: #ffffff;
  border-top: 4px solid $color-blue;
  border-bottom: solid 1px #e6e6e6;
  .nav-menu {
    padding: 0 25px;
    margin: 0 auto;
    width: 1150px;
  }
  .auto-width {
    width: auto;
  }
  .el-menu-item {
    padding: 0;
    margin: 0 20px;
  }
  .josh-logo {
    height: 26px;
  }
  .lang-select {
    display: block;
    margin: 0 15px;
    height: 60px;
    line-height: 60px;
    color: $font-color;
    cursor: pointer;
  }
  .lang-select:hover {
    color: inherit;
  }
  .el-dropdown-link {
    display: block!important;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  a {
    display: block;
    height: 100%;
    text-decoration: none;
  }
}
.el-dropdown-menu a {
  display: block;
  height: 100%;
  color: inherit;
  text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/components/public/NavBar.vue